(() => {
  'use strict';
  const script = document.currentScript;
  const logo = script && script.dataset.logo;
  const formSelector = 'form[data-testid="klaviyo-form-YrArpZ"]';
  let selectedGift = '';
  function brandForm(form) {
    form.id = 'pm-gift-form';
    if(selectedGift) form.dataset.pmGift = selectedGift;
    form.querySelectorAll('a[href*="/policies/privacy-policy"]').forEach(a=>a.href='/pages/personvernerklaering');
    const email = form.querySelector('.palmera-email-step');
    if(email && !email.dataset.pmReady){
      email.dataset.pmReady='true';
      const paragraphs=Array.from(email.children).filter(el=>el.tagName==='P');
      const names=['pm-step-title','pm-gift-images','pm-gift-value','pm-step-copy'];
      paragraphs.forEach((p,i)=>{if(names[i])p.classList.add(names[i]);});
      if(paragraphs[0])paragraphs[0].textContent='Få gavekoden din.';
      if(paragraphs[3])paragraphs[3].textContent='Meld deg på med e-postadressen din.';
      if(logo){const img=document.createElement('img');img.className='pm-email-logo';img.src=logo;img.alt='Palmera';email.prepend(img);}
    }
    if (!logo) return;
    form.querySelectorAll('.palmera-v3-logo img').forEach(img => {
      if (img.getAttribute('src') === logo) return;
      img.removeAttribute('srcset');
      img.src = logo;
    });
  }
  function scan(node) {
    if (!(node instanceof Element)) return;
    const parentForm = node.closest(formSelector);
    if (parentForm) brandForm(parentForm);
    node.querySelectorAll(formSelector).forEach(brandForm);
  }
  function ready() {
    document.addEventListener('change',event=>{const input=event.target;if(input.matches('.palmera-farge input[type="radio"]')){selectedGift=input.getAttribute('aria-label')||'';const form=input.closest(formSelector);if(form)form.dataset.pmGift=selectedGift;}});
    scan(document.body);
    new MutationObserver(records => {
      records.forEach(record => record.addedNodes.forEach(scan));
    }).observe(document.body, { childList: true, subtree: true });
    const footer = document.querySelector('.footer');
    if (footer && !footer.querySelector('.palmera-cookie-settings')) {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'palmera-cookie-settings';
      button.textContent = 'Informasjonskapsler';
      button.addEventListener('click', () => {
        if (window.Cookiebot && typeof window.Cookiebot.renew === 'function') window.Cookiebot.renew();
      });
      (footer.querySelector('.footer__bottom') || footer.querySelector('.page-width') || footer).append(button);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready, {once:true});
  else ready();
})();
/* Klaviyo sometimes renders a mobile teaser without its native dismiss control. */
(() => {
  let dismissed = false;
  function reconcileTeasers() {
    document.querySelectorAll('.kl-teaser-YrArpZ').forEach(teaser => {
      if (dismissed) { teaser.setAttribute('data-pm-dismissed',''); return; }
      const trigger = teaser.querySelector('[role="button"]');
      if(trigger)trigger.setAttribute('aria-label','Åpne velkomstgaven – gratis dekorpotte');
      const nativeClose = teaser.querySelector('.klaviyo-close-form');
      const fallback = teaser.querySelector('.pm-teaser-close');
      if (nativeClose) { if (fallback) fallback.remove(); return; }
      if (fallback) return;
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'pm-teaser-close';
      button.setAttribute('aria-label','Lukk gavefanen');
      button.innerHTML = '<svg aria-hidden="true" viewBox="0 0 20 20" fill="none"><path d="M5 5L15 15M15 5L5 15" stroke="currentColor" stroke-linecap="round"/></svg>';
      button.addEventListener('click', event => {
        event.preventDefault();
        event.stopPropagation();
        dismissed = true;
        teaser.setAttribute('data-pm-dismissed','');
      });
      (teaser.querySelector('[data-testid="animated-teaser"]') || teaser).append(button);
    });
  }
  function start() {
    reconcileTeasers();
    new MutationObserver(reconcileTeasers).observe(document.body,{childList:true,subtree:true});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',start,{once:true}); else start();
})();

(() => {
  const pending = new WeakSet();
  const selector = '[role="dialog"]:has(form[data-testid="klaviyo-form-YrArpZ"])';
  function visible(el) {
    const s=getComputedStyle(el);
    return el.getClientRects().length && s.display!=='none' && s.visibility!=='hidden' && Number(s.opacity)>0;
  }
  function check() {
    document.querySelectorAll(selector).forEach(dialog => {
      if (!dialog.style.animationName.includes('fadeout')) {
        if(dialog.hasAttribute('data-pm-closed-dialog')) dialog.removeAttribute('data-pm-closed-dialog');
        return;
      }
      if(pending.has(dialog)) return;
      pending.add(dialog);
      setTimeout(() => {
        pending.delete(dialog);
        if(!dialog.isConnected || !dialog.style.animationName.includes('fadeout')) return;
        // Keep the closing animation alive so Klaviyo can finish its state transition.
        dialog.removeAttribute('data-kl-scroll-locking-modal');
        const anotherOpen=Array.from(document.querySelectorAll('[role="dialog"],.drawer[open],#pm-consent:not([hidden])')).some(el=>el!==dialog && visible(el));
        if(!anotherOpen) { document.body.classList.remove('klaviyo-prevent-body-scrolling'); if(document.body.style.overflow==='hidden') document.body.style.removeProperty('overflow'); }
      },450);
    });
  }
  function start(){
    new MutationObserver(check).observe(document.body,{subtree:true,childList:true,attributes:true,attributeFilter:['style']});
    check();
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})();


/* Show the gift tab only outside focused shopping tasks. */
(() => {
 const root=document.documentElement;
 let queued=false;
 function update(){
  queued=false;
  const path=location.pathname;
  const excluded=/\/(cart|checkout|checkouts|account)(\/|$)/.test(path);
  const product=document.body.classList.contains('product-template')||/\/products\//.test(path);
  const buy=document.querySelector('[id^="ProductSubmitButton-"]');
  const pastIntro=product && window.scrollY>=window.innerHeight && (buy ? buy.getBoundingClientRect().bottom<0 : window.scrollY>=window.innerHeight*1.5);
  const state=excluded||(product&&!pastIntro)?'blocked':'allowed';
  if(root.dataset.pmTeaserContext!==state)root.dataset.pmTeaserContext=state;
 }
 function schedule(){if(!queued){queued=true;requestAnimationFrame(update);}}
 function start(){
  update();
  addEventListener('scroll',schedule,{passive:true});
  addEventListener('resize',schedule,{passive:true});
  addEventListener('pageshow',schedule);
  document.addEventListener('shopify:section:load',schedule);
  new ResizeObserver(schedule).observe(document.body);
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})();
